/**
 * hs-judge-me-reviews.js  v10.0  (build 20260512-2360)
 * 数据：cdn.judge.me/reviews/reviews_for_widget 公开接口分页拉全量
 * 图片展示：API 直接返回 pictures_urls.[{original,small,compact,huge}]
 * 写评论：完全自定义 modal，直接 POST https://api.judge.me/api/v1/reviews（CORS 全开）
 * 写评论 + 图片上传（v10 新增）：
 *   1. GET https://api.judge.me/api/v1/pictures/presigned_data?shop_domain=&platform=
 *   2. POST 图片到 S3 me.judge.temp-files（multipart，不要带 Content-Type 字段）
 *   3. 把 S3 返回的 key 挂到 picture_keys[i]，跟 review POST 一起提交
 * 高亮：每条评论用启发式算法选 1-2 个关键短语，加 .cjm-hl 黄色 marker 高亮
 * 星星：橙色 #EE8113，svg/path inline fill + stroke=none 防主题 CSS 覆盖
 */
(function () {
  'use strict';
  console.log('[cjm] hs-judge-me-reviews.js v10.0 loaded');

  /* 官方 widget 已经 display:none（CSS），不再依赖。无需 JS 干预。 */
  var OFFICIAL_SELECTOR = '[id*="1768657941496813c2"]';
  function getOfficialEl() { return document.querySelector(OFFICIAL_SELECTOR); }

  /* ─── Helpers ─── */
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return ''; }
  }

  var STAR_FILLED = '#EE8113';
  var STAR_EMPTY  = '#E5D5B0';

  function starSVG(filled) {
    var color = filled ? STAR_FILLED : STAR_EMPTY;
    /* fill+stroke 同时设在 svg 和 path 上，加 inline !important 防主题全局 CSS
       用 fill:currentColor / stroke:currentColor 把星星变黑或加描边 */
    var styleAttr = 'fill:' + color + '!important;stroke:none!important';
    return '<svg viewBox="0 0 24 24" fill="' + color + '" stroke="none" ' +
      'style="' + styleAttr + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path fill="' + color + '" stroke="none" style="' + styleAttr + '" ' +
      'd="M12 17.77L18.18 21.5l-1.64-7.03L22 9.74l-7.19-.61L12 2.5 9.19 9.13 2 9.74l5.46 4.73L5.82 21.5z"/>' +
      '</svg>';
  }

  function starsHTML(n) {
    n = Math.round(Number(n) || 0);
    var out = '';
    for (var i = 1; i <= 5; i++) out += starSVG(i <= n);
    return out;
  }

  /* ─── 写评论 modal（完全自定义，直接 POST https://api.judge.me/api/v1/reviews）───
     - api.judge.me 的这个端点 access-control-allow-origin: * 允许浏览器跨域 POST
     - 不需要 token / captcha；FormData 必须字段：shop_domain, platform, id,
       name, email, rating, title, body
     - 图片：picture_keys[0..n] = 上传到 S3 me.judge.temp-files 后拿到的 key */
  var WR_PRODUCT_ID = '';

  /* ─── 图片上传（presigned → S3 → key 挂到 review FormData）─── */
  var PIC_MAX_COUNT     = 5;
  var PIC_MAX_SIZE_MB   = 10;
  var PIC_MIME_ALLOWED  = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
  /* 缓存 presigned data，整个 modal 生命周期复用一份（有效期 3 小时，足够单次提交） */
  var presignedCache    = null;
  /* 当前已上传成功的图片 keys：[{ id, key, file, status }] */
  var picState          = [];

  function fetchPresignedData(shopDomain) {
    if (presignedCache) return Promise.resolve(presignedCache);
    var url = 'https://api.judge.me/api/v1/pictures/presigned_data'
            + '?shop_domain=' + encodeURIComponent(shopDomain)
            + '&platform=shopify';
    return fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('presigned_data HTTP ' + r.status);
        return r.json();
      }).then(function (j) {
        presignedCache = j; return j;
      });
  }

  function uploadPictureToS3(file, shopDomain) {
    /* presigned policy 只允许的字段：fields(*) + key + file。带 Content-Type 会 403 */
    return fetchPresignedData(shopDomain).then(function (pd) {
      var fd = new FormData();
      Object.keys(pd.fields).forEach(function (k) { fd.append(k, pd.fields[k]); });
      var safeName = (file.name || 'photo').replace(/[^A-Za-z0-9_.-]+/g, '_').slice(-60);
      var key = pd.key_prefix + Date.now() + '_' + Math.floor(Math.random() * 1e6) + '_' + safeName;
      fd.append('key', key);
      fd.append('file', file, safeName);
      return fetch(pd.url, { method: 'POST', body: fd, credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('S3 HTTP ' + r.status);
          return key;
        });
    });
  }

  function readImageDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload  = function () { resolve(reader.result); };
      reader.onerror = function () { reject(new Error('read fail')); };
      reader.readAsDataURL(file);
    });
  }

  /* 把缩略图节点插入预览网格 */
  function appendThumb(grid, addBox, item, dataUrl) {
    var t = document.createElement('div');
    t.className = 'cjm-pic-thumb is-uploading';
    t.dataset.cjmPicId = item.id;
    t.innerHTML =
      '<img alt="" src="' + dataUrl + '">' +
      '<button type="button" class="cjm-pic-thumb-remove" aria-label="Remove photo">&#x2715;</button>' +
      '<span class="cjm-pic-thumb-spinner" aria-hidden="true"></span>';
    grid.insertBefore(t, addBox);
    /* 删除按钮 */
    t.querySelector('.cjm-pic-thumb-remove').addEventListener('click', function () {
      removePicById(item.id);
    });
    return t;
  }

  function refreshAddBoxVisibility() {
    var addBox = document.getElementById('cjm-pic-add');
    if (!addBox) return;
    var visiblePics = picState.filter(function (p) { return p.status !== 'removed'; }).length;
    if (visiblePics >= PIC_MAX_COUNT) addBox.classList.add('is-hidden');
    else                              addBox.classList.remove('is-hidden');
  }

  function removePicById(id) {
    var idx = -1;
    for (var i = 0; i < picState.length; i++) if (picState[i].id === id) { idx = i; break; }
    if (idx < 0) return;
    picState[idx].status = 'removed';
    var node = document.querySelector('.cjm-pic-thumb[data-cjm-pic-id="' + id + '"]');
    if (node && node.parentElement) node.parentElement.removeChild(node);
    refreshAddBoxVisibility();
  }

  function setThumbState(id, state) {
    var node = document.querySelector('.cjm-pic-thumb[data-cjm-pic-id="' + id + '"]');
    if (!node) return;
    node.classList.remove('is-uploading', 'is-failed');
    if (state === 'uploading') node.classList.add('is-uploading');
    if (state === 'failed')    node.classList.add('is-failed');
  }

  function bindPictureUpload(modal) {
    var input  = modal.querySelector('#cjm-pic-input');
    var grid   = modal.querySelector('#cjm-pic-grid');
    var addBox = modal.querySelector('#cjm-pic-add');
    var hint   = modal.querySelector('#cjm-pic-hint');
    if (!input || !grid || !addBox) return;

    var shopDomain = (function () {
      var hidden = modal.querySelector('input[name="shop_domain"]');
      return hidden ? hidden.value : '';
    })();

    /* label.cjm-pic-add 自带触发 input click，这里只补键盘可达 */
    addBox.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
    });

    input.addEventListener('change', function () {
      var files = Array.from(input.files || []);
      input.value = '';
      if (!files.length) return;
      if (hint) { hint.style.color = ''; hint.textContent = 'JPG / PNG / GIF / WEBP, max 10 MB each.'; }

      files.forEach(function (file) {
        var alive = picState.filter(function (p) { return p.status !== 'removed' && p.status !== 'failed'; }).length;
        if (alive >= PIC_MAX_COUNT) {
          if (hint) { hint.style.color = '#b3261e'; hint.textContent = 'Up to ' + PIC_MAX_COUNT + ' photos.'; }
          return;
        }
        if (PIC_MIME_ALLOWED.indexOf(file.type) < 0) {
          if (hint) { hint.style.color = '#b3261e'; hint.textContent = 'Unsupported file: ' + (file.name || ''); }
          return;
        }
        if (file.size > PIC_MAX_SIZE_MB * 1024 * 1024) {
          if (hint) { hint.style.color = '#b3261e'; hint.textContent = (file.name || 'File') + ' is over ' + PIC_MAX_SIZE_MB + ' MB.'; }
          return;
        }

        var item = {
          id: 'pic_' + Date.now() + '_' + Math.floor(Math.random() * 1e6),
          file: file,
          key:  null,
          status: 'uploading'
        };
        picState.push(item);
        refreshAddBoxVisibility();

        readImageDataUrl(file).then(function (dataUrl) {
          appendThumb(grid, addBox, item, dataUrl);
          return uploadPictureToS3(file, shopDomain);
        }).then(function (key) {
          item.key = key; item.status = 'ok';
          setThumbState(item.id, 'ok');
        }).catch(function (err) {
          console.warn('[cjm] picture upload failed', err);
          item.status = 'failed';
          setThumbState(item.id, 'failed');
          /* 让用户能删除失败 thumb 重传；3s 后自动复位 hint */
          if (hint) { hint.style.color = '#b3261e'; hint.textContent = 'Upload failed for ' + (file.name || 'a file') + '. Click x to remove and retry.'; }
        });
      });
    });
  }

  function clearPictureUpload() {
    picState = [];
    var grid = document.getElementById('cjm-pic-grid');
    if (grid) {
      Array.from(grid.querySelectorAll('.cjm-pic-thumb')).forEach(function (n) { n.parentElement.removeChild(n); });
    }
    var hint = document.getElementById('cjm-pic-hint');
    if (hint) { hint.style.color = ''; hint.textContent = 'JPG / PNG / GIF / WEBP, max 10 MB each.'; }
    refreshAddBoxVisibility();
  }

  function setWriteReviewIds(encodedProdId, encodedShopId, productId) {
    WR_PRODUCT_ID = productId || WR_PRODUCT_ID;
  }

  function getModal() { return document.getElementById('cjm-modal'); }

  var modalInited = false;
  function initModalOnce() {
    if (modalInited) return;
    var modal = getModal();
    if (!modal) return;
    modalInited = true;

    /* 把 modal 移到 body 末尾，避免 section 容器 overflow/transform 影响 fixed */
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    /* 关闭：close 按钮、overlay 点击、Esc */
    modal.querySelectorAll('[data-cjm-close]').forEach(function (el) {
      el.addEventListener('click', closeWriteReview);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeWriteReview();
    });

    /* 评分星星交互 */
    var ratingInput = modal.querySelector('#cjm-rating-input');
    var ratingValue = modal.querySelector('#cjm-rating-value');
    if (ratingInput && ratingValue) {
      var stars = ratingInput.querySelectorAll('.cjm-rating-star');
      var paint = function (n) {
        stars.forEach(function (s, i) { s.innerHTML = starSVG(i < n); });
      };
      paint(parseInt(ratingValue.value, 10) || 5);
      stars.forEach(function (s) {
        s.addEventListener('mouseover', function () { paint(parseInt(s.dataset.value, 10)); });
        s.addEventListener('click', function () {
          ratingValue.value = s.dataset.value;
          paint(parseInt(s.dataset.value, 10));
        });
        s.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            ratingValue.value = s.dataset.value;
            paint(parseInt(s.dataset.value, 10));
          }
        });
      });
      ratingInput.addEventListener('mouseleave', function () {
        paint(parseInt(ratingValue.value, 10) || 5);
      });
    }

    /* 图片上传交互 */
    bindPictureUpload(modal);

    /* form submit */
    var form = modal.querySelector('#cjm-review-form');
    var errBox = modal.querySelector('#cjm-form-error');
    var submitBtn = modal.querySelector('#cjm-submit-btn');
    var formWrap = modal.querySelector('#cjm-modal-form-wrap');
    var successWrap = modal.querySelector('#cjm-form-success-wrap');

    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg;
      errBox.classList.add('is-show');
    }
    function clearError() {
      if (!errBox) return;
      errBox.classList.remove('is-show');
      errBox.textContent = '';
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        /* WR_PRODUCT_ID 从 review API 拿到的 product id；hidden 也已填充 */
        if (WR_PRODUCT_ID) {
          var hiddenId = form.querySelector('input[name="id"]');
          if (hiddenId && (!hiddenId.value || hiddenId.value === '0')) {
            hiddenId.value = WR_PRODUCT_ID;
          }
        }

        var fd = new FormData(form);
        var email = (fd.get('email') || '').toString().trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError('Please enter a valid email address.');
          return;
        }
        if (!fd.get('title') || !fd.get('body') || !fd.get('name')) {
          showError('Please fill in all required fields.');
          return;
        }

        /* 等所有图片上传完。失败的跳过；如果还在上传中，按钮显示 'Uploading…' 并轮询。 */
        var pending  = picState.filter(function (p) { return p.status === 'uploading'; });
        if (pending.length) {
          showError('Photos are still uploading, please wait a moment…');
          return;
        }
        var picKeys = picState
          .filter(function (p) { return p.status === 'ok' && p.key; })
          .map(function (p) { return p.key; });
        picKeys.forEach(function (k, i) { fd.append('picture_keys[' + i + ']', k); });

        submitBtn.disabled = true;
        var origLabel = submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';

        fetch('https://api.judge.me/api/v1/reviews', {
          method: 'POST',
          body: fd,
          credentials: 'omit'
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; })
            .catch(function () { return { ok: r.ok, status: r.status, json: {} }; });
        }).then(function (res) {
          submitBtn.disabled = false;
          submitBtn.textContent = origLabel;
          if (res.ok || res.status === 200 || res.status === 201) {
            if (formWrap) formWrap.style.display = 'none';
            if (successWrap) successWrap.style.display = 'block';
            form.reset();
            clearPictureUpload();
          } else {
            var msg = (res.json && (res.json.message || res.json.error)) ||
                      'Submission failed (HTTP ' + res.status + '). Please try again.';
            showError(msg);
          }
        }).catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = origLabel;
          showError('Network error. Please check your connection and try again.');
        });
      });
    }
  }

  function triggerWriteReview() {
    initModalOnce();
    var modal = getModal();
    if (!modal) { console.warn('[cjm] modal not found'); return; }

    /* 重置 form 状态 */
    var formWrap = modal.querySelector('#cjm-modal-form-wrap');
    var successWrap = modal.querySelector('#cjm-form-success-wrap');
    if (formWrap) formWrap.style.display = 'block';
    if (successWrap) successWrap.style.display = 'none';
    var errBox = modal.querySelector('#cjm-form-error');
    if (errBox) { errBox.classList.remove('is-show'); errBox.textContent = ''; }
    /* 上次提交残留的图片（成功或失败）一起清掉 */
    clearPictureUpload();

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var first = modal.querySelector('input[type="text"], textarea');
      if (first) first.focus();
    }, 100);
  }

  function closeWriteReview() {
    var modal = getModal();
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* 让 modal 在 DOM 加载完成后初始化（即使没评论也要可用） */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalOnce);
  } else {
    initModalOnce();
  }

  /* ─── 评论关键词高亮 ───
     启发式：从评论中找出 1-2 个 4–8 词的有意义短语，包装为 <mark class="cjm-hl">
     选择策略：以正面/评价性关键词为锚点，提取该词所在的短句片段。 */
  var HL_TRIGGER_WORDS = [
    'love', 'loved', 'amazing', 'beautiful', 'gorgeous', 'stunning', 'perfect',
    'incredible', 'excellent', 'fantastic', 'wonderful', 'great', 'lovely',
    'crisp', 'sharp', 'detailed', 'durable', 'sturdy', 'high quality', 'quality',
    'authentic', 'genuine', 'consistent', 'reliable', 'soft', 'comfortable',
    'fresh', 'calming', 'soothing', 'meditative', 'intentional', 'unique',
    'recommend', 'recommended', 'gift', 'cleaner', 'crispier', 'best',
    'faint', 'subtle', 'rich', 'warm', 'elegant', 'thoughtful', 'memorable',
    'impressed', 'surprised', 'compliment', 'compliments', 'noticed'
  ];

  /* 只把每条评论"高亮"一次：选包含 trigger word 的最短自然语段
     返回 HTML 字符串（已 escape） */
  function highlightReview(plainText) {
    if (!plainText) return '';
    var safe = esc(plainText);
    /* 按 . ! ? ; 切分句子，但保留分隔符 */
    var sentences = safe.split(/([.!?;](?:\s|$))/);
    /* 重组成 [{text, isHit}] */
    var fragments = [];
    for (var i = 0; i < sentences.length; i += 2) {
      var seg = sentences[i] + (sentences[i + 1] || '');
      if (!seg) continue;
      fragments.push(seg);
    }

    /* 找第一个含 trigger word 的句子作为高亮目标 */
    var hitIdx = -1;
    for (var j = 0; j < fragments.length; j++) {
      var lc = fragments[j].toLowerCase();
      for (var k = 0; k < HL_TRIGGER_WORDS.length; k++) {
        if (lc.indexOf(HL_TRIGGER_WORDS[k]) >= 0) { hitIdx = j; break; }
      }
      if (hitIdx >= 0) break;
    }
    if (hitIdx < 0) return safe;

    /* 在命中的句子里，进一步缩到包含 trigger word 的子片段（按逗号切）*/
    var sentence = fragments[hitIdx];
    var parts = sentence.split(/(,\s*|—\s*|–\s*)/);
    var bestPart = sentence;
    for (var p = 0; p < parts.length; p += 2) {
      var lcPart = (parts[p] || '').toLowerCase();
      for (var q = 0; q < HL_TRIGGER_WORDS.length; q++) {
        if (lcPart.indexOf(HL_TRIGGER_WORDS[q]) >= 0 &&
            parts[p].length >= 8 && parts[p].length <= 80) {
          bestPart = parts[p].trim();
          break;
        }
      }
      if (bestPart !== sentence) break;
    }

    /* 把该 bestPart 包装成 <mark> */
    var bestEsc = bestPart.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(' + bestEsc + ')');
    return safe.replace(re, '<mark class="cjm-hl">$1</mark>');
  }

  /* ─── （deprecated v9）从官方 widget DOM 提取图片
     v9 起用 cdn.judge.me API 直接返回 pictures_urls，此函数不再调用，但保留代码 ─── */
  function syncPicturesFromOfficial() {
    var officialEl = getOfficialEl();
    if (!officialEl) return false;

    var revEls = officialEl.querySelectorAll('[data-review-id], .jdgm-rev');
    if (!revEls.length) return false;

    var sawAny = false;
    revEls.forEach(function (revEl) {
      var rid = revEl.getAttribute('data-review-id') || '';
      if (!rid) return;
      var picImgs = revEl.querySelectorAll(
        '.jdgm-rev__pic img, .jdgm-rev__pic--single img, [class*="rev__pic"] img'
      );
      if (!picImgs.length) return;

      var pics = [];
      picImgs.forEach(function (img) {
        var src = img.getAttribute('data-src') || img.src || '';
        if (!src || src.indexOf('data:') === 0) return;
        /* 转 high-res 链接：compact -> original */
        var fullSrc = src.replace(/\/compact\//, '/original/')
                          .replace(/_compact\./, '_original.');
        pics.push({ thumb: src, full: fullSrc });
      });
      if (!pics.length) return;

      /* 找到所有 cjm-card[data-rid] 匹配的卡片，注入图片 */
      var cards = document.querySelectorAll('.cjm-card[data-rid="' + rid + '"]');
      cards.forEach(function (card) {
        if (card.querySelector('.cjm-card-photos')) return; /* 已注入 */
        var html = '<div class="cjm-card-photos">';
        pics.forEach(function (p) {
          html += '<a class="cjm-photo-link" href="' + esc(p.full) + '">' +
                  '<img class="cjm-photo-thumb" src="' + esc(p.thumb) +
                  '" alt="Review photo" loading="lazy" width="64" height="64"></a>';
        });
        html += '</div>';
        /* 插入到 footer 之前 */
        var footer = card.querySelector('.cjm-card-footer');
        if (footer) {
          footer.insertAdjacentHTML('beforebegin', html);
        } else {
          card.insertAdjacentHTML('beforeend', html);
        }
        /* 给新插入的链接绑灯箱 */
        card.querySelectorAll('.cjm-photo-link').forEach(function (a) {
          a.addEventListener('click', function (e) {
            e.preventDefault();
            openLightbox(a.getAttribute('href'));
          });
        });
        sawAny = true;
      });
    });
    return sawAny;
  }

  /* 持续监听 + 轮询，直到拿到所有图片（或 30 秒超时） */
  function startPictureSync() {
    var started = Date.now();
    var lastTry = 0;

    function maybeRun() {
      var now = Date.now();
      if (now - lastTry < 800) return; /* 限频 */
      lastTry = now;
      syncPicturesFromOfficial();
      if (now - started > 30000) {
        if (officialObserver) officialObserver.disconnect();
        if (intervalId) clearInterval(intervalId);
      }
    }

    var officialEl = getOfficialEl();
    var officialObserver = null;
    if (officialEl) {
      officialObserver = new MutationObserver(maybeRun);
      officialObserver.observe(officialEl, { childList: true, subtree: true });
    }
    var intervalId = setInterval(maybeRun, 1500);
    setTimeout(maybeRun, 200);
    setTimeout(maybeRun, 1000);
    setTimeout(maybeRun, 3000);
  }

  /* ─── 全局灯箱（避免每个 widget 实例各自创建） ─── */
  var globalLightbox = null;
  function openLightbox(src) {
    if (!globalLightbox) {
      var lb = document.createElement('div');
      lb.className = 'cjm-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML =
        '<div class="cjm-lightbox-overlay"></div>' +
        '<div class="cjm-lightbox-content">' +
          '<button class="cjm-lightbox-close" aria-label="Close">&#x2715;</button>' +
          '<img class="cjm-lightbox-img" src="" alt="Review photo">' +
        '</div>';
      document.body.appendChild(lb);
      lb.querySelector('.cjm-lightbox-overlay').addEventListener('click', closeLightbox);
      lb.querySelector('.cjm-lightbox-close').addEventListener('click', closeLightbox);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
      globalLightbox = lb;
    }
    globalLightbox.querySelector('.cjm-lightbox-img').src = src;
    globalLightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (globalLightbox) {
      globalLightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* ─── Widget ─── */
  function CjmWidget(rootEl) {
    this.root      = rootEl;
    this.sectionId = rootEl.dataset.section;
    this.productId = rootEl.dataset.product;
    this.shopDomain = rootEl.dataset.shop || (window.Shopify && window.Shopify.shop) || location.hostname;
    this.perPage   = parseInt(rootEl.dataset.perPage, 10) || 50;
    this._init();
  }

  /* 用官方 widget 用的同一接口拉全量评论
     https://cdn.judge.me/reviews/reviews_for_widget?product_id=...&page=N&per_page=10
     该接口 ACAO=*，浏览器跨域 OK
     返回 {number_of_reviews, average_rating, reviews:[...], pagination:{total_pages, current_page}} */
  function fetchAllReviewsFromCdn(productId, shopDomain, maxPages) {
    /* 接口 per_page 上限是 30 */
    var base = 'https://cdn.judge.me/reviews/reviews_for_widget'
      + '?product_id=' + encodeURIComponent(productId)
      + '&shop_domain=' + encodeURIComponent(shopDomain)
      + '&platform=shopify'
      + '&sort_by=created_at&sort_dir=desc'
      + '&per_page=30&widget_theme=carousel';

    function fetchPage(page) {
      return fetch(base + '&page=' + page, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    return fetchPage(1).then(function (d1) {
      if (!d1) return null;
      var totalPages = (d1.pagination && d1.pagination.total_pages) || 1;
      var stop = Math.min(totalPages, maxPages || 20);
      if (stop <= 1) return d1;
      var jobs = [];
      for (var p = 2; p <= stop; p++) jobs.push(fetchPage(p));
      return Promise.all(jobs).then(function (rest) {
        var allReviews = (d1.reviews || []).slice();
        rest.forEach(function (dd) {
          if (dd && Array.isArray(dd.reviews)) allReviews = allReviews.concat(dd.reviews);
        });
        d1.reviews = allReviews;
        return d1;
      });
    });
  }

  CjmWidget.prototype._init = function () {
    var self = this;

    function processData(d) {
      var reviews = (d.reviews || []).slice().sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      }).slice(0, self.perPage);

      /* 保存 encoded ID 给 Write Review fallback */
      var first = reviews[0];
      if (first) {
        setWriteReviewIds(first.encoded_product_id, first.encoded_shop_id, self.productId);
      } else {
        setWriteReviewIds('', '', self.productId);
      }

      self._updateHeader(d, reviews.length);
      self._renderCarousel(reviews);
      self._bindWriteBtn();
    }

    /* 直接用 cdn.judge.me 公开接口拉全量评论（最多 30 页 = 300 条） */
    fetchAllReviewsFromCdn(self.productId, self.shopDomain, 30).then(function (d) {
      if (d && d.reviews && d.reviews.length) {
        processData(d);
        return;
      }
      /* fallback：尝试从 inline window.jdgm.data 取（前几条） */
      try {
        var w = window.jdgm;
        var dd = w && w.data && w.data.reviewWidget && w.data.reviewWidget[self.productId];
        if (dd && Array.isArray(dd.reviews) && dd.reviews.length) {
          processData(dd);
          return;
        }
      } catch (e) {}
      self._showEmpty();
    }).catch(function () {
      self._showEmpty();
    });
  };

  /* Header */
  CjmWidget.prototype._updateHeader = function (d, count) {
    var sid   = this.sectionId;
    var avg   = parseFloat(d.average_rating) || 0;
    var total = d.number_of_reviews || count;

    var scoreRow = document.getElementById('cjm-score-row-' + sid);
    var scoreNum = document.getElementById('cjm-score-num-' + sid);
    var starsEl  = document.getElementById('cjm-stars-lg-'  + sid);
    var countEl  = document.getElementById('cjm-count-'     + sid);

    if (scoreRow && avg) {
      if (scoreNum) scoreNum.textContent = avg.toFixed(1);
      if (starsEl)  starsEl.innerHTML    = starsHTML(Math.round(avg));
      if (countEl)  countEl.textContent  = 'Based on ' + total + ' review' + (total !== 1 ? 's' : '');
      scoreRow.style.display = 'flex';
    }
  };

  /* Carousel */
  var CARD_W    = 305 + 18;
  var CARD_W_MB = 272 + 18;

  CjmWidget.prototype._renderCarousel = function (reviews) {
    if (!reviews.length) { this._showEmpty(); return; }

    var self     = this;
    var isMobile = window.innerWidth <= 767;
    var cards    = reviews.map(function (r) { return self._buildCard(r); }).join('');

    var track = document.createElement('div');
    track.className = 'cjm-track';
    track.innerHTML = isMobile ? cards : (cards + cards);

    this.root.innerHTML = '';
    this.root.appendChild(track);

    /* 灯箱（inline 数据中已带的图） */
    track.querySelectorAll('.cjm-photo-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openLightbox(link.getAttribute('href'));
      });
    });

    var outer = document.getElementById('cjm-carousel-outer-' + this.sectionId);
    var nav   = document.getElementById('cjm-nav-' + this.sectionId);
    if (nav) nav.style.display = 'flex';

    if (!isMobile) self._startAutoScroll(outer);

    var cw = isMobile ? CARD_W_MB : CARD_W;
    self._bindNavBtns(outer, cw);

    outer.addEventListener('mouseenter', function () { self._pauseScroll(); });
    outer.addEventListener('mouseleave', function () { self._resumeScrollAfterDelay(2000); });
    outer.addEventListener('touchstart', function () { self._pauseScroll(); }, { passive: true });
    outer.addEventListener('touchend',   function () { self._resumeScrollAfterDelay(3000); }, { passive: true });
  };

  CjmWidget.prototype._buildCard = function (r) {
    var rid      = r.id || r.uuid || '';
    var rating   = Number(r.rating) || 5;
    var title    = esc(r.title || '');
    /* cdn.judge.me 接口返回 body_html（含 <p>）；inline data 给的是纯文本 body */
    var bodyTxt  = (r.body_html || '').replace(/<[^>]+>/g, '').trim() || (r.body || '');
    /* highlightReview 内部已 escape，并在合适位置插 <mark class="cjm-hl">…</mark> */
    var body     = highlightReview(bodyTxt);
    var name     = esc(r.reviewer_name || 'Anonymous');
    var date     = esc(fmtDate(r.created_at));
    /* 用户要求：所有评论统一展示 Verified 徽章（店铺评论都来自走 Judge.me
       邮件邀请下单客户，整体可视为已核身），不再依赖 r.verified_buyer。 */
    var verified = true;

    /* 解析 inline JSON 里的图片
       Judge.me 的实际格式（验证过）：pictures_urls = [{original, small, compact, huge}]
       URL 字段直接平铺在每个对象上，不在 .urls 子对象里 */
    var picsArr  = Array.isArray(r.pictures_urls) ? r.pictures_urls : [];
    var photosHTML = '';
    if (picsArr.length) {
      photosHTML = '<div class="cjm-card-photos">';
      picsArr.forEach(function (p) {
        var thumb = '', full = '';
        if (typeof p === 'string' && p) { thumb = p; full = p; }
        else if (p && typeof p === 'object') {
          /* 兼容两种格式：直接平铺 OR 嵌套在 .urls */
          var u = p.urls || p;
          thumb = u.compact || u.small || u.medium || p.thumb_url || p.small_url || '';
          full  = u.huge || u.original || u.large || p.original_url || thumb;
        }
        if (thumb) {
          photosHTML +=
            '<a class="cjm-photo-link" href="' + esc(full || thumb) + '">' +
            '<img class="cjm-photo-thumb" src="' + esc(thumb) +
            '" alt="Review photo" loading="lazy" width="64" height="64"></a>';
        }
      });
      photosHTML += '</div>';
    }

    var verHTML = verified
      ? '<span class="cjm-verified">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        'Verified</span>'
      : '';

    return '<div class="cjm-card" data-rid="' + esc(rid) + '">' +
      '<div class="cjm-card-stars">' + starsHTML(rating) + '</div>' +
      (title ? '<h3 class="cjm-card-title">' + title + '</h3>' : '') +
      (body  ? '<p class="cjm-card-body">'  + body  + '</p>'  : '') +
      photosHTML +
      '<div class="cjm-card-footer">' +
        '<span class="cjm-author">' + name + '</span>' +
        verHTML +
        (date ? '<span class="cjm-date">' + date + '</span>' : '') +
      '</div></div>';
  };

  CjmWidget.prototype._showEmpty = function () {
    var wrapper = document.getElementById('cjm-section-' + this.sectionId);
    if (wrapper) wrapper.style.display = 'none';
  };

  CjmWidget.prototype._bindWriteBtn = function () {
    var btn = document.getElementById('cjm-write-btn-' + this.sectionId);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      triggerWriteReview();
    });
  };

  /* Auto scroll */
  CjmWidget.prototype._startAutoScroll = function (outer) {
    var self = this;
    self._scrollOuter  = outer;
    self._scrollPaused = false;
    setTimeout(function () {
      var halfWidth = outer.scrollWidth / 2;
      if (halfWidth <= 0) return;
      var speed = 0.7;
      function tick() {
        if (!self._scrollPaused && self._scrollOuter) {
          self._scrollOuter.scrollLeft += speed;
          if (self._scrollOuter.scrollLeft >= halfWidth) {
            self._scrollOuter.scrollLeft -= halfWidth;
          }
        }
        self._scrollRaf = requestAnimationFrame(tick);
      }
      self._scrollRaf = requestAnimationFrame(tick);
    }, 150);
  };

  CjmWidget.prototype._bindNavBtns = function (outer, cw) {
    var self    = this;
    var prevBtn = document.getElementById('cjm-prev-' + this.sectionId);
    var nextBtn = document.getElementById('cjm-next-' + this.sectionId);
    function scrollBy(delta) {
      self._pauseScroll();
      var half = outer.scrollWidth / 2;
      if (delta < 0 && outer.scrollLeft < cw) outer.scrollLeft = half - cw;
      outer.scrollBy({ left: delta, behavior: 'smooth' });
      self._resumeScrollAfterDelay(3000);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-cw); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(cw); });
  };

  CjmWidget.prototype._pauseScroll = function () {
    this._scrollPaused = true;
    if (this._resumeTimer) { clearTimeout(this._resumeTimer); this._resumeTimer = null; }
  };

  CjmWidget.prototype._resumeScrollAfterDelay = function (delay) {
    var self = this;
    if (self._resumeTimer) clearTimeout(self._resumeTimer);
    self._resumeTimer = setTimeout(function () { self._scrollPaused = false; }, delay || 2000);
  };

  /* Boot */
  function boot() {
    document.querySelectorAll('[id^="cjm-root-"]').forEach(function (el) {
      if (!el.dataset.initialized) {
        el.dataset.initialized = '1';
        new CjmWidget(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[id^="cjm-root-"]').forEach(function (el) {
      el.removeAttribute('data-initialized');
      new CjmWidget(el);
    });
  });
})();
